__turbopack_context__.v({
  "card": "styles-module__0_bt6a__card",
  "container": "styles-module__0_bt6a__container",
  "desktopButton": "styles-module__0_bt6a__desktopButton",
  "downloadButton": "styles-module__0_bt6a__downloadButton",
  "grid": "styles-module__0_bt6a__grid",
  "image": "styles-module__0_bt6a__image",
  "leftColumn": "styles-module__0_bt6a__leftColumn",
  "mobileButton": "styles-module__0_bt6a__mobileButton",
  "overlay": "styles-module__0_bt6a__overlay",
  "subtitle": "styles-module__0_bt6a__subtitle",
  "textWrapper": "styles-module__0_bt6a__textWrapper",
  "wrapper": "styles-module__0_bt6a__wrapper",
});
